import PropTypes from "prop-types";
import "./styles.css";
import { useLeadForm } from "../../../context/leadform";
import { OptionType } from "../../../Leadform/options";

type SelectProps = {
  options: string[] | OptionType[];
  placeholder?: string;
  statekey: string;
  label?: string;
  inline?: boolean;
  currency?: boolean;
};

function Select({
  options,
  placeholder = "Please select an option",
  statekey,
  label,
  inline,
  currency,
}: SelectProps) {
  const { responses, updateValue } = useLeadForm();

  const formatCurrency = (value: string) => {
    if (currency) {
      const numericValue = parseFloat(value.replace(/[^0-9.-]+/g, ""));
      if (!isNaN(numericValue)) {
        return numericValue.toLocaleString("en-GB", {
          style: "currency",
          currency: "GBP",
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        });
      }
    }
    return value;
  };

  return (
    <div className={`Select Select_Inline_${inline}`}>
      {label && <label htmlFor="statekey">{label}</label>}
      <select
        name={statekey}
        value={responses[statekey] ?? ""}
        onChange={(e) => updateValue(statekey, e.target.value)}
      >
        <option value="" disabled>
          {placeholder}
        </option>
        {typeof options[0] === "string"
          ? (options as string[]).map((option, index) => (
              <option key={index} value={option}>
                {formatCurrency(option)}
              </option>
            ))
          : (options as OptionType[]).map((option, index) => (
              <option key={index} value={option.value}>
                {formatCurrency(option.label ? option.label : option.value)}
              </option>
            ))}
      </select>
    </div>
  );
}

export default Select;
